module.exports = "/components/components/inputSkeletonPlaceholder-0fa3a9.html";